angular.module('zc.commonApi')

.factory 'projectServiceResponseTransformer', ($filter) ->
  doTransform = (project) ->
    project.installed_at = $filter('changeDatetimeFrom')('regionToLocal', project.installed_at, 'date', project.region)
    project.companyinfo_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.companyinfo_confirmed_at, 'date', project.region)
    project.siteinfo_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.siteinfo_confirmed_at, 'date', project.region)
    project.tracking_tag_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.tracking_tag_confirmed_at, 'date', project.region)
    project.conversion_tag_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.conversion_tag_confirmed_at, 'date', project.region)
    project.first_campaign_start_at = $filter('changeDatetimeFrom')('regionToLocal', project.first_campaign_start_at, 'date', project.region)
    project.contracted_at = $filter('changeDatetimeFrom')('regionToLocal', project.contracted_at, 'date', project.region)
    project.terminated_at = $filter('changeDatetimeFrom')('regionToLocal', project.terminated_at, 'date', project.region)
    project.lens_contracted_at = $filter('changeDatetimeFrom')('regionToLocal', project.lens_contracted_at, 'date', project.region)
    project.lens_cancelled_at = $filter('changeDatetimeFrom')('regionToLocal', project.lens_cancelled_at, 'date', project.region)
    project.iw_cancelled_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_cancelled_at, 'date', project.region)
    project.iw_contracted_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_contracted_at, 'date', project.region)
    project.iw_trial_started_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_trial_started_at, 'date', project.region)
    project.iw_trial_end_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_trial_end_at, 'date', project.region)
    project.trial_started_at = $filter('changeDatetimeFrom')('regionToLocal', project.trial_started_at, 'date', project.region)
    project.trial_end_at = $filter('changeDatetimeFrom')('regionToLocal', project.trial_end_at, 'date', project.region)

    if project.started_campaigns
      for campaign in project.started_campaigns
        campaign.start_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.start_at, 'date', project.region)
        campaign.end_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.end_at, 'date', project.region)

    project

  return (data) ->
    try
      obj = angular.fromJson(data)
      if obj.project
        doTransform(obj.project)
      if obj.projects
        for project in obj.projects
          doTransform(project)
      obj
    catch
      {}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/project_response.transformer.js.coffee